'use client'

import MainNav from '@/app/components/MainNav'
import ContractModeler from '@/app/components/calculators/ContractModeler'

export default function ContractModelerPage() {
  return (
    <div className="space-y-8 pb-16">
      <MainNav />
      <div className="mx-auto max-w-6xl px-6">
        <ContractModeler />
      </div>
    </div>
  )
}
